<template>
  <div class="form">
    <Form2ItemInput
      v-model="identifier"
      ref="identifier"
      label="账号"
      :required="true"
      :disabled="true"
      max="11"
      @keyup-enter="submit"
      :rule="[{ type: `string`, required: true, message: `账号不能为空`, trigger: `blur` }]"
    />
    <Form2ItemInput
      v-model="imageCaptcha"
      ref="imageCaptcha"
      label="图片验证码"
      type="imageCaptcha"
      :required="true"
      max="4"
      :rule="[
        { required: true, message: `图片验证码不能为空`, trigger: `blur` },
        { pattern: pattern.isLetterOrNumber(4, 0), message: `图形验证码不正确`, trigger: `blur`}
      ]"
    />
    <Form2ItemInput
      v-model="smsCaptcha"
      ref="smsCaptcha"
      label="短信验证码"
      type="smsCaptcha"
      :required="true"
      max="4"
      @sms-query="smsQuery"
      @keyup-enter="submit"
      :rule="[
        { required: true, message: `短信验证码不能为空`, trigger: `blur` },
        { pattern: pattern.isNumber(4), message: `短信验证码不正确`, trigger: `blur`}
      ]"
    />
    <div>
      <Button @click="$router.push(`/user/safe/list`)">
        取消
      </Button>
      <Button
        class="ml"
        type="primary"
        @click="submit">
        下一步
      </Button>
    </div>
  </div>
</template>

<script>
import Form2ItemInput from '@/components/form2-item-input';
import {captchaSms, updatePasswordVerify} from '@/service';
import pattern from '@/util/pattern';

export default {
  name: 'Index',
  components: {Form2ItemInput},
  data() {
    return {
      pattern,
      identifier: '',
      imageCaptcha: '',
      smsCaptcha: '',
    };
  },
  watch: {
    '$store.state.user.userAuth.identifier'(value) {
      this.identifier = value;
    },
  },
  methods: {
    smsQuery(next) {
      Promise.all([
        this.$refs['identifier'].validate(),
        this.$refs['imageCaptcha'].validate(),
      ]).then(([valid1, valid2]) => {
        if (valid1 && valid2) {
          captchaSms({
            deviceId: this.$store.getters['system/deviceId'],
            mobile: this.$store.state.user.user.mobile,
            imageCaptcha: this.imageCaptcha,
            senderId: '3',
          }).then((res) => {
            next(60);
          });
        }
      });
    },
    submit() {
      Promise.all([
        this.$refs['identifier'].validate(),
        this.$refs['smsCaptcha'].validate(),
      ]).then(([valid1, valid2]) => {
        if (valid1 && valid2) {
          updatePasswordVerify({
            identifier: this.identifier,
            smsCaptcha: this.smsCaptcha,
          }).then(({result, resultDesc}) => {
            if (result === true) {
              this.$emit('success');
            } else {
              this.$Message.success(resultDesc);
            }
          });
        }
      });
    },
  },
  mounted() {
    if (this.$store.state.user.userAuth.identifier) {
      this.identifier = JSON.parse(JSON.stringify(this.$store.state.user.userAuth.identifier));
    }
  },
};
</script>
